import { Injectable } from '@angular/core';
import { standardCommand } from '../../../core/model/command';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';

@Injectable()
export class PaymentMethodCommandHandlerResolver extends CommandHandlerResolver {
  constructor(editHandler: EditCommandHandler) {
    super();
    this.addHandler(standardCommand.edit, editHandler);
  }
}
